<template>
	<div
		class="main-loading-panel modal-body mobile-prompt-wrapper"
		style="background-color: #ffffff;"
	>
		<div v-if="!hasAccepted" class="accept-terms">
			<div>
				<img src="/images/pronto/pronto-logo-name-white.png" />
			</div>

			<div class="mobile-prompt-lgtext">
				{{ $t('onboarding_mobileprompt_title') }}
			</div>

			<i18n-t
				keypath="onboarding_mobileprompt_email_subtitle"
				tag="div"
				class="mobile-prompt-smtext"
			>
				<template #Email>
					<strong v-text="store.auth.user?.emails?.[0]?.email" />
				</template>
			</i18n-t>

			<div
				class="mobile-prompt-smtext"
				style="margin-bottom: 20px; margin-top: 20px;"
			>
				{{ $t('onboarding_mobileprompt_or_label') }}
			</div>

			<div class="mobile-prompt-links">
				<span
					><a
						href="https://apps.apple.com/us/app/pronto-team-communication/id1258991852"
						target="_blank"
						><img
							src="/images/pronto/rounded-appstore-img.svg"
							alt="Apple App Store"
							style="height: 50px; width: 150px;" /></a
				></span>
				<span
					><a
						href="https://play.google.com/store/apps/details?id=com.hitlabs.pronto&hl=en_US"
						target="_blank"
						><img
							src="/images/pronto/rounded-playstore-img.svg"
							alt="Google Play Store"
							style="height: 50px; width: 167px; margin-left: 15px;" /></a
				></span>
			</div>

			<div class="mobile-prompt-gotapp" @click="store.termsPrompt = false">
				<span>{{ $t('onboarding_mobileprompt_okay_button') }}</span>
				<span
					><img
						src="/images/pronto/blue-right-arrow.svg"
						style="margin-bottom: -3px; margin-left: 5px;"
				/></span>
			</div>
		</div>
	</div>
</template>

<script>
import store from '../store'
import { post } from '../helpers/api'

export default {
	data() {
		return {
			store,
			hasAccepted: false,
		}
	},

	mounted() {
		//when the page loads we'll send the link to the user
		this.sendAppLink()
	},

	methods: {
		sendAppLink() {
			//whatever endpoint server endpoint for sending a customized app link goes here
			post('/api/v1/user.sendwelcomemessage').catch((error) => {
				console.error(error)
			})
		},
	},
}
</script>
<style scoped>
.mobile-prompt-wrapper {
	background-image: url('/images/pronto/angle-background-small.png');
	background-repeat: no-repeat;
	background-position: center top;
	background-size: 100% 153px;
}

.accept-terms {
	text-align: center;
	padding-top: 40px;
}

.mobile-prompt-lgtext {
	font-size: 28px;
	font-family: Avenir-Heavy;
	color: #2c2d30;
	margin-top: 90px;
	margin-bottom: 20px;
}

.mobile-prompt-smtext {
	font-size: 16px;
	font-family: Avenir-Book;
	color: #2c2d30;
	padding-left: 72px;
	padding-right: 72px;
}

.mobile-prompt-links {
	margin-top: 20px;
	margin-bottom: 20px;
}

.mobile-prompt-gotapp {
	font-family: Avenir-Heavy;
	font-size: 20px;
	color: #448de6;
	cursor: pointer;
	padding-top: 20px;
	font-weight: normal;
}

.mobile-prompt-lgtext strong {
	font-family: Avenir-Heavy;
}
</style>
